import React from 'react';
import { Link } from 'react-router-dom';
import logout from '../Components/Image/logout.png'
import Sidebar from '../Components/Sidebar';
import { Button } from 'react-bootstrap';
import TableComp from '../Components/ReusableTable'
// import Carousel from '../Components/Carousel.js';
import {connect} from 'react-redux'
import {getSupplierPOs} from '../store/actions/supplierActions'
import {getBlankDocumentsSearch} from '../store/actions/masterActions'
import SearchBar from '../Components/SearchBar';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import AuthHandlerInstance from '../Classes/AuthHandler'
import formatDate from '../Classes/FormatDate'
import env from '../ENV';
const FILESERVER_ROOT_URL = env.FILE_SERVER_URL;


  
  class Dashboard extends React.Component {
    constructor(props) {
      super(props);
      this.state={
        QAPlanningtabledata: [{"ponumber":"123", "vendor": "ABC", "createdOn": "12/12/12", "poamount":"1234", "location": "location1"},
        {"ponumber":"123", "vendor": "ABC", "createdOn": "12/12/12", "poamount":"1234", "location": "location2"},
        {"ponumber":"123", "vendor": "ABC", "createdOn": "12/12/12", "poamount":"1234", "location": "location3"}
      ],
      supplierName: "",
      tableData: [],
      searchInput: "",
      data: [
        {"seq": 1,	"DocumentName": "Format_Bar Chart", "documentID": 7},
        {"seq": 2,	"DocumentName": "Format_Technical Clarification", "documentID": 8},
        {"seq": 3,	"DocumentName": "Format_Kick Off meeting", "documentID": 9},
        {"seq": 4,	"DocumentName": "Format_NDT_VT", "documentID": 10},
        {"seq": 5,	"DocumentName": "Format_NDT_MT & PT", "documentID": 11},
        {"seq": 6,	"DocumentName": "Format_NDT_UT", "documentID": 12},
        {"seq": 7,	"DocumentName": "Format_Dimension Inspection", "documentID": 13},
        {"seq": 8,	"DocumentName": "Format_Hydro testing", "documentID": 14},
        {"seq": 9,	"DocumentName": "Format_Pneumatic Pressure Test", "documentID": 15},
        {"seq": 10,	"DocumentName": "Format_Pressure Testing (Hydraulics)", "documentID": 16},
        {"seq": 11,	"DocumentName": "Format_List of pending items - rework", "documentID": 17},
        {"seq": 12,	"DocumentName": "Format_Coating Inspection", "documentID": 18},
        {"seq": 13,	"DocumentName": "Format_Packing", "documentID": 19},
        {"seq": 14,	"DocumentName": "Format_Transportation", "documentID": 20}]
        
    }
    this.handleDataLoading = this.handleDataLoading.bind(this)
  }
  componentDidMount(){
    
    this.handleDataLoading()
    
  }

  handleDataLoading = async() => {

    var userId = AuthHandlerInstance.getUserID()
    await this.props.getBlankDocumentsSearch()
    this.setState({ tableData: this.props.master.blankdocument.recordset })
    console.log(this.props.master.blankdocument.recordset, "master")

  }

  // ? handle search input
  handleISearch = (e) => {
        
    let searchInput = e.target.value
    
    this.setState({
        searchInput
    })
    
    console.log(this.state.searchInput)
    
  } 
  
  
  
  // ? handle searching
  handleSearching = async() => {
      
      var userId = AuthHandlerInstance.getUserID()
      let searchTerm = this.state.searchInput
      await this.props.getBlankDocumentsSearch({SearchTerm: searchTerm})
      console.log("Search complete, results are : ", this.props.master.blankdocument.recordset)
      await this.setState({ tableData: this.props.master.blankdocument.recordset, searchInput: "" })

    }
  
  render(){
    
    
    // this.props.supplier.pos && this.setState({ supplierName: this.props.supplier.pos[0].VendorName })
    
      // ? on button click of table function
      const handleClickTableButton = (item) => () => {
        // write your logic
        alert(JSON.stringify(item))
      }
      
      // ? table column headers
        const tableConstants = (handleEdit) => {
          return [
            {
              title: 'Document Name',
              render: rowData => {
                return <span>{rowData.DocumentName}</span>;
              },
            },
              {
                title: 'Actions',
                render: rowData => {
                  return (
                  <div className="view-button">
                    <a href={FILESERVER_ROOT_URL + "files/Documents/" + rowData.DocumentID + "/download"} target="_blank" download>
                      <FontAwesomeIcon icon={"download"} title="View" color={"black"} size="lg" />
                    </a>
                  </div>
                  
                  )
                },
              },
            ];
          };

        

        return(

            <div className="Container-fluid p-4">
                        <div className="row ">
                          <div className="col-md-8 header"><b>Sample/Blank Documents</b></div>
                            
                          
                          <div className="col-md-4 xs={last} pt-2" style={{paddingRight: 30}}>
                          <SearchBar placeholder="Search" value={this.state.searchInput} searchInputHandler={(e) => { this.handleISearch(e) }} searchClick={this.handleSearching} label="Search"  btnName=""  />
                          </div> 

                       </div>
                      <div className="row"> 
                        <div className="col pt-4 centre-alligned">
                         <TableComp cols={tableConstants(handleClickTableButton)} className="w-50" data={this.state.tableData}/>
                        </div>
                      </div>   
          
            </div>
        )
    }
}



const mapStateToProps  = (state) => ({ supplier:state.supplier, master: state.masterReducer})
export default connect(mapStateToProps, {getSupplierPOs, getBlankDocumentsSearch})(Dashboard)
